import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBolt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13 2 4.5 13.2c-.4.5 0 1.3.6 1.3H10l-1.1 7.1c-.1.7.8 1.1 1.3.5L19.5 10.8c.4-.5 0-1.3-.6-1.3H14l1.1-7.1c.1-.7-.8-1.1-1.3-.5Z" })
});
export default SvgIconBolt;
